import cls from 'classnames'
import React from 'react'

interface SwitchProps {
  options: { label: string; value: any }[]
  value: any
  onChange: (value: any) => void
}

export const Switch: React.FC<SwitchProps> = ({ options, value, onChange }) => {
  const elements = options.map((option, i) => (
    <React.Fragment key={option.value}>
      {i > 0 && <span>|</span>}
      <span
        onClick={() => {
          if (option.value !== value) {
            onChange(option.value)
          }
        }}
        className={cls('px-6px', option.value === value ? 'text-blue-600' : 'hover:text-blue-800')}
      >
        {option.label}
      </span>
    </React.Fragment>
  ))

  return (
    <span className='text-xs ml-12px select-none transition' onClick={(e) => e.stopPropagation()}>
      {elements}
    </span>
  )
}
